import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import styles from "./ContactPage.module.css"
import contactImg from "../../assets/images/call-center.png"
import wpIcon from "../../assets/images/wp-icon.png"
import instaLogo from "../../assets/images/insta-logo.png"

export default function ContactPage() {
  return (
    <>
      <Header />
      <main className={styles.main}>
        <div className={styles.container}>
          {/* Hero Section */}
          <section className={styles.heroSection}>
            <div className={styles.heroLeft}>
              <div className={styles.heroImageContainer}>
                <div className={styles.imageWrapper}>
                  <img src={contactImg} alt="Contact" className={styles.heroImage} />
                </div>
                <div className={styles.heroOverlay}>
                  <h1 className={styles.heroTitle}>GET IN TOUCH</h1>
                  <p className={styles.heroSubtitle}>Always here for you</p>
                </div>
              </div>
            </div>
            
            <div className={styles.heroRight}>
              <div className={styles.turquoiseFrame}>
                <h2 className={styles.connectTitle}>Stay Connect Us</h2>
                <div className={styles.socialIconsContainer}>
                  <a href="https://wa.me/905337674950" target="_blank" rel="noreferrer">
                    <img src={wpIcon} alt="WhatsApp" className={styles.socialIcon} />
                  </a>
                  <a href="https://instagram.com/estaverde_clinic" target="_blank" rel="noreferrer">
                    <img src={instaLogo} alt="Instagram" className={styles.socialIcon} />
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Address Section */}
          <section className={styles.addressSection}>
            <div className={styles.addressContainer}>
              <div className={styles.addressHeader}>
                <div className={styles.addressIcon}>📍</div>
                <h2 className={styles.addressTitle}>Turkey Office</h2>
              </div>
              <p className={styles.addressText}>
                Merdivenköy Mah. Nur Sokak No:1/1 Kat:12 D:115 Business İstanbul  Kadiköy / İstanbul / Turkey
              </p>
              <p className={styles.contactInfo}>
                <a href="https://wa.me/905337674950" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>+90 533 767 49 50</a> | <a href="mailto:info@estaverde.com" style={{ color: 'inherit', textDecoration: 'none' }}>info@estaverde.com</a>
              </p>
              
              <div className={styles.mapContainer}>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1064.7246168669437!2d29.06751577558115!3d40.9925160800014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac7c1e1925583%3A0x3f63a6514d0d97c7!2sEstaVerde%20Clinic!5e0!3m2!1str!2str!4v1763123092266!5m2!1str!2str" width="100%" height="450" style={{border: 0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  )
}
